import { normalizeId } from "./utility";

export const fieldToKeyValue = (field, formObj) => {
  switch (field.type) {
    case "table-input": {
      return getTableData(field, formObj);
    }
    case "text": {
      return getInputData(field, formObj);
    }
    case "datalist-text": {
      return getInputData(field, formObj);
    }
    case "text-area": {
      return getInputData(field, formObj);
    }
    case "number": {
      return getInputData(field, formObj);
    }
    case "multi-text": {
      return getMultiInputData(field, formObj);
    }
    case "multi-text-area": {
      return getMultiInputData(field, formObj, "textarea");
    }
    case "radio": {
      return getRadioGroupData(field, formObj);
    }
    case "checkbox-group": {
      return getCheckBoxGroupData(field, formObj);
    }
    case "radio-score": {
      return getRadioScoreData(field, formObj);
    }
    case "checkbox": {
      return getCheckBoxData(field, formObj);
    }
    case "dropdown": {
      return getInputData(field, formObj);
    }
    case "file": {
      return getFileData(field, formObj);
    }
  }
  return null;
};

const getTableData = (table, formObj) => {
  const tableName = table.id || table.title;
  const tableId = table.id || normalizeId(table.title);

  var tbodyRowCount = document.getElementById(tableId).tBodies[0].rows.length;
  const tableRows = [];

  for (let rowIndex = 0; rowIndex < tbodyRowCount; rowIndex++) {
    const row = [];
    table.tableFields.forEach((field) => {
      row.push(
        formObj[normalizeId(tableId + "-" + field.title + "-" + rowIndex)]
      );
    });
    tableRows.push(row);
  }
  return {
    key: tableName,
    value: tableRows,
  };
};

const getInputData = (field, formObj) => {
  const inputName = field.id || field.title;
  const inputId = field.id || normalizeId(field.title);

  return {
    key: inputName,
    value:
      field.variant === "date" && formObj[inputId]
        ? getDateWithTimezone(formObj[inputId])
        : formObj[inputId],
  };
};

const getFileData = (field, formObj) => {
  const inputName = field.id || field.title;
  const inputId = field.id || normalizeId(field.title);

  const files = formObj[inputId];

  return {
    key: inputName,
    value: files,
  };
};

const getMultiInputData = (field, formObj, tagName = "input") => {
  const inputName = field.id || field.title;
  const inputContainerId = field.id || normalizeId(field.title);

  const inputCount = document
    .getElementById(inputContainerId)
    .getElementsByTagName(tagName).length;

  const inputRows = [];

  for (let rowIndex = 0; rowIndex < inputCount; rowIndex++) {
    const row = formObj[inputContainerId + "-" + rowIndex];
    inputRows.push(row);
  }

  return {
    key: inputName,
    value: inputRows,
  };
};

const getRadioGroupData = (field) => {
  const inputName = field.id || field.title;
  const radioGroup = [...document.getElementsByName(inputName)];
  const checkedRadio = radioGroup.filter((radio) => radio.checked)[0].value;

  return {
    key: inputName,
    value: checkedRadio,
  };
};

const getCheckBoxGroupData = (field) => {
  const inputName = field.groupName || field.id;
  const radioGroup = [...document.getElementsByName(inputName)];
  const checkedRadio = radioGroup
    .filter((radio) => radio.checked)
    .map((radio) => radio.value);

  return {
    key: inputName,
    value: checkedRadio,
  };
};

const getRadioScoreData = (field, formObj) => {
  const inputName = field.id || field.title;
  const value = {};

  field.scoreFields.forEach((scoreField) => {
    const radioGroup = [...document.getElementsByName(scoreField)];
    const checkedRadio = radioGroup.filter((radio) => radio.checked)[0].value;
    value[scoreField] = parseInt(checkedRadio);
  });

  return {
    key: inputName,
    value,
  };
};

const getCheckBoxData = (field, formObj) => {
  const inputName = field.id || field.title;
  const inputId = field.id || normalizeId(field.title);

  return {
    key: inputName,
    value: formObj[inputId],
  };
};

const getDateWithTimezone = (dateString) => {
  try {
    return new Date(dateString.split("-").join("/")).toISOString();
  } catch (e) {
    console.log(dateString, e);
  }
};
